import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, toDisplayString, createTextVNode, withCtx, createSlots } from "vue";
import { CdrImg, CdrText, CdrButton, IconCheckLg } from "@rei/cedar";
const _hoisted_1 = {
  class: "acquisition-billboard__visuals"
};
const _hoisted_2 = {
  class: "acquisition-billboard__product-image"
};
const _hoisted_3 = {
  class: "reward-card acquisition-billboard__card"
};
const _hoisted_4 = {
  class: "acquisition-billboard__card-meta"
};
const _hoisted_5 = {
  class: "sr-only"
};
const _hoisted_6 = {
  ariaHidden: "true",
  class: "num"
};
const _hoisted_7 = {
  class: "bonus-card acquisition-billboard__card"
};
const _hoisted_8 = {
  class: "acquisition-billboard__card-meta"
};
const _hoisted_9 = {
  class: "num"
};
const _hoisted_10 = {
  class: "acquisition-billboard__offer mbr-p-f-s"
};
const _hoisted_11 = {
  class: "mbr-p-f-s__equation"
};
const _hoisted_12 = {
  class: "mbr-p-f-s__addend addend addend--rewards"
};
const _hoisted_13 = {
  class: "mbr-p-f-s__addend addend addend--mabc"
};
const _hoisted_14 = {
  class: "mbr-p-f-s__sum sum"
};
const _hoisted_15 = {
  class: "mbr-p-f-s__ctas"
};
const _hoisted_16 = {
  class: "mbr-p-f-s__subheading"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AcquisitionBillboard",
  props: {
    buttonText: {
      default: ""
    },
    bonusCardMath: {
      default: null
    },
    bonusCardValue: {
      default: ""
    },
    imageTileAlt: {
      default: ""
    },
    imageTileSrc: {
      default: ""
    },
    isInterstitial: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isMembershipAdded: {
      type: Boolean,
      default: false
    },
    heading: {
      default: ""
    },
    productEstimatedReward: {
      default: ""
    },
    rewardMath: {
      default: null
    },
    subheading: {
      default: ""
    },
    totalEstimatedReward: {
      default: ""
    }
  },
  emits: ["acquisitionDetailsClick", "addMembershipToCart", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const location = computed(() => props.isInterstitial ? "interstitial" : "on-page");
    const buttonModifier = computed(() => props.isMembershipAdded || props.isLoading ? "secondary" : void 0);
    const containerClasses = computed(() => ({
      "acquisition-billboard": true,
      [`acquisition-billboard--${location.value}`]: true
    }));
    const handleMembershipClick = () => {
      emit("addMembershipToCart", {
        linkName: `too far membership billboard ${location.value}_Add a lifetime membership — $30`
      });
    };
    const handleShowDetails = () => {
      emit("metricsClick", {
        linkName: `acquisition membership billboard ${location.value}_details`
      });
      emit("acquisitionDetailsClick", {
        id: "new-member-offer-popup-modal",
        labelIsTitle: true,
        label: "New Member Offer Details",
        contentClass: "new-member-offer-details-modal",
        modalContent: "NewMemberOfferDetailsModal",
        modalProps: "newMemberOfferDetailsModalProps"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(containerClasses.value)
      }, [createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createVNode(unref(CdrImg), {
        src: _ctx.imageTileSrc,
        class: normalizeClass(_ctx.imageTileAlt)
      }, null, 8, ["src", "class"])]), createElementVNode("div", _hoisted_3, [createVNode(unref(CdrImg), {
        alt: "",
        class: "reward-card__graphic",
        role: "presentation",
        src: "https://www.rei.com/dam/21508778_member-card-visual.png?im=Resize,width=240"
      }), createVNode(unref(CdrImg), {
        alt: "",
        class: "reward-card__stamp",
        role: "presentation",
        src: "https://www.rei.com/dam/21507141_member-benefit-badge-10-percent-member-reward-white.png?im=Resize,width=240"
      }), _cache[2] || (_cache[2] = createElementVNode("div", {
        class: "acquisition-billboard__card-bg"
      }, null, -1)), createElementVNode("div", _hoisted_4, [createElementVNode("span", _hoisted_5, toDisplayString(`10% co-op member reward: $${_ctx.productEstimatedReward}`), 1), createElementVNode("span", _hoisted_6, [_cache[0] || (_cache[0] = createElementVNode("sup", null, "$", -1)), createTextVNode(toDisplayString(_ctx.productEstimatedReward), 1)]), _cache[1] || (_cache[1] = createElementVNode("span", {
        ariaHidden: "true",
        class: "copy"
      }, " Member Reward ", -1))])]), createElementVNode("div", _hoisted_7, [createVNode(unref(CdrImg), {
        alt: "",
        class: "bonus-card__lockup",
        role: "presentation",
        src: "https://www.rei.com/dam/made-for-life-outside?im=Resize,width=240"
      }), createVNode(unref(CdrImg), {
        alt: "",
        class: "bonus-card__mem-diamond",
        role: "presentation",
        src: "https://www.rei.com/dam/21028995_-mem_membership_symbol_main_yellow.png?im=Resize,width=240"
      }), createElementVNode("div", _hoisted_8, [createElementVNode("span", _hoisted_9, [_cache[3] || (_cache[3] = createElementVNode("sup", null, "$", -1)), createTextVNode(toDisplayString(_ctx.bonusCardValue), 1)]), _cache[4] || (_cache[4] = createElementVNode("span", {
        class: "copy"
      }, "Member Bonus Card", -1))])])]), createElementVNode("div", _hoisted_10, [createVNode(unref(CdrText), {
        class: "mbr-p-f-s__heading",
        tag: "h2"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.heading), 1)]),
        _: 1
      }), createElementVNode("div", _hoisted_11, [createElementVNode("div", _hoisted_12, [createVNode(unref(CdrText), {
        class: "addend__total"
      }, {
        default: withCtx(() => [createTextVNode(" $" + toDisplayString(_ctx.productEstimatedReward), 1)]),
        _: 1
      }), createVNode(unref(CdrText), {
        class: "addend__text addend__text--upper"
      }, {
        default: withCtx(() => {
          var _a;
          return [createTextVNode(toDisplayString((_a = _ctx.rewardMath) == null ? void 0 : _a.heading), 1)];
        }),
        _: 1
      }), createVNode(unref(CdrText), {
        class: "addend__text"
      }, {
        default: withCtx(() => {
          var _a;
          return [createTextVNode(toDisplayString((_a = _ctx.rewardMath) == null ? void 0 : _a.subheading), 1)];
        }),
        _: 1
      })]), createVNode(unref(CdrText), {
        class: "mbr-p-f-s__operator"
      }, {
        default: withCtx(() => _cache[5] || (_cache[5] = [createTextVNode(" + ")])),
        _: 1,
        __: [5]
      }), createElementVNode("div", _hoisted_13, [createVNode(unref(CdrText), {
        class: "addend__total"
      }, {
        default: withCtx(() => [createTextVNode(" $" + toDisplayString(_ctx.bonusCardValue), 1)]),
        _: 1
      }), createVNode(unref(CdrText), {
        class: "addend__text addend__text--upper"
      }, {
        default: withCtx(() => {
          var _a;
          return [createTextVNode(toDisplayString((_a = _ctx.bonusCardMath) == null ? void 0 : _a.heading), 1)];
        }),
        _: 1
      }), createVNode(unref(CdrText), {
        class: "addend__text"
      }, {
        default: withCtx(() => {
          var _a;
          return [createTextVNode(toDisplayString((_a = _ctx.bonusCardMath) == null ? void 0 : _a.subheading), 1)];
        }),
        _: 1
      })]), createVNode(unref(CdrText), {
        class: "mbr-p-f-s__operator"
      }, {
        default: withCtx(() => _cache[6] || (_cache[6] = [createTextVNode(" = ")])),
        _: 1,
        __: [6]
      }), createElementVNode("div", _hoisted_14, [createVNode(unref(CdrText), {
        class: "sum__total"
      }, {
        default: withCtx(() => [createTextVNode(" $" + toDisplayString(_ctx.totalEstimatedReward), 1)]),
        _: 1
      }), createVNode(unref(CdrText), {
        class: "sum__description"
      }, {
        default: withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" Value ")])),
        _: 1,
        __: [7]
      })])]), createElementVNode("div", _hoisted_15, [createElementVNode("div", _hoisted_16, toDisplayString(_ctx.subheading), 1), createVNode(unref(CdrButton), {
        modifier: buttonModifier.value,
        class: "mbr-p-f-s__add-to-cart",
        "data-ui": "mbr-pays-for-self-add-membership-to-cart",
        onClick: handleMembershipClick
      }, createSlots({
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.buttonText) + " ", 1)]),
        _: 2
      }, [_ctx.isMembershipAdded ? {
        name: "icon-left",
        fn: withCtx(() => [createVNode(unref(IconCheckLg), {
          "inherit-color": ""
        })]),
        key: "0"
      } : void 0]), 1032, ["modifier"]), createVNode(unref(CdrButton), {
        class: "mbr-p-f-s__terms",
        "data-ui": "mbr-pays-for-self-terms",
        modifier: "link",
        "aria-label": "terms",
        onClick: handleShowDetails
      }, {
        default: withCtx(() => _cache[8] || (_cache[8] = [createElementVNode("sup", null, "*", -1), createElementVNode("span", null, "Details", -1)])),
        _: 1,
        __: [8]
      })])])], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AcquisitionBillboard.mjs.map
